import { v4 as uuidv4 } from 'uuid';
import { useEffect } from 'react';
import { getCookie, setCookies } from 'cookies-next';
import * as Sentry from '@sentry/nextjs';
import addYears from 'date-fns/addYears';

const DynamicFingerprint = ({ initializeFingerprint, fingerprint }) => {
    useEffect(() => {
        if (!fingerprint) {
            const storedFingerprint = getCookie('fp');

            if (storedFingerprint) {
                initializeFingerprint(storedFingerprint);

                return;
            }

            const uuid = uuidv4({
                random: crypto.getRandomValues(new Uint8Array(16))
            });

            Sentry.captureMessage(`Client side, generated client fingerprint: ${uuid}`, 'info');

            initializeFingerprint(uuid);
            setCookies('fp', uuid, {
                expires: addYears(new Date(), 1)
            });
        }
    }, []);

    return null;
};

export default DynamicFingerprint;
